<template>
  <div v-html="html[$i18n.locale]"/>
</template>

<script>

export default {
    data(){
        return {
            html: ''
        }
    },
    computed: {
        page_id(){
            return this.$route.params.page_id
        }
    },
    watch: {
        async page_id(){
            await this.fetchHTML()
        }
    },
    async created(){
        await this.fetchHTML()
    },
    methods: {
        async fetchHTML(){
            this.html = this.page_id + ' en HTML'
        }
    }
}
</script>

<style lang="scss" scoped>

</style>